import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../reducers/index";

const persistConfig = {
  key: "root",
  storage,
};

const configurePersistReducer = () => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  return persistedReducer;
};

export default configurePersistReducer();
